const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Tharindu", "Tharindu N", "Tharindu Nayanajith"],
	},

	{
		page: "about",
		description:
"I am a Blockchain Developer with expertise in Ethereum, Bitcoin, and zero-knowledge proofs. I have experience building decentralized solutions that are secure, scalable, and accessible. Passionate about pushing the boundaries of blockchain technology, I enjoy tackling complex challenges and continuously expanding my skills. Committed to delivering high-quality code that adheres to best practices, I am always seeking new opportunities to innovate and grow in the blockchain space.",
			keywords: ["Pavitra Agarwal", "Pavitra ", "Pavitra blockchain"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
			keywords: ["Pavitra Agarwal", "Pavitra ", "Pavitra blockchain"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Pavitra Agarwal", "Pavitra ", "Pavitra blockchain"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
			keywords: ["Pavitra Agarwal", "Pavitra ", "Pavitra blockchain"],
	},
];

export default SEO;
